var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5137 38.6729C21.2275 38.6729 21.792 38.3574 22.1904 37.7432L37.8789 13.04C38.1777 12.5586 38.2939 12.1934 38.2939 11.8115C38.2939 10.8984 37.6963 10.3008 36.7832 10.3008C36.1191 10.3008 35.7539 10.5166 35.3555 11.1475L20.4473 34.9043L12.7109 24.7773C12.2959 24.1963 11.8809 23.9639 11.2832 23.9639C10.3369 23.9639 9.68945 24.6113 9.68945 25.5244C9.68945 25.9062 9.85547 26.3379 10.1709 26.7363L18.7871 37.71C19.2852 38.3574 19.7998 38.6729 20.5137 38.6729Z",
    fill: "#8E8E93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopied);
export default __webpack_public_path__ + "static/media/copied.bbc367520905f5ab5262bba806717a06.svg";
export { ForwardRef as ReactComponent };